import styles from './404.module.scss';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Container } from '@mui/material';

const NotFoundPage = () => {
  const history = useNavigate();

  const goBackHome = () => history(-1);

  return (
    <Container className={styles.container}>
      <Box className={styles.wrapper}>
        <Button onClick={goBackHome} variant='contained' color='primary' className={styles.button}>
          Go Back Home
        </Button>
      </Box>
    </Container>
  );
};

export default NotFoundPage;
